import { Country } from "../../../../features/countries/types";
import { StateStatistics } from "../../../../features/statistics/types";
import { convertValueToLocalString } from "../../../../utils/convertValueToLocalString";

const escapeHtml = (str: string): string =>
  str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

interface HoverTooltipProps {
    facilities_value: string;
    direct_jobs_value: string;
    indirect_jobs_value: string;
    gdp_contribution_value: string;
}

export function hoverTooltip(
  country: Country | HoverTooltipProps | StateStatistics,
  name: string,
  showFacilities?: boolean
) {
  // USA state-level data uses StateStatistics shape
  if ('data_points' in country) {
    const { economic_impact, employment_impact } = country.data_points;
    const totalEmployment = employment_impact.direct_jobs_value + employment_impact.indirect_jobs_value;
    return `
      <div>
        <h3>${escapeHtml(name)}</h3>
        <ul>
          <li>Total value added: ${convertValueToLocalString(String(economic_impact.value_added))} ${escapeHtml(economic_impact.value_added_unit)}</li>
          <li>Total employment: ${convertValueToLocalString(String(totalEmployment))}</li>
        </ul>
      </div>
    `;
  }

  return `
    <div>
      <h3>Data available for your related country</h3>
      <h3>${escapeHtml(name)}</h3>
      <ul>
        ${
          showFacilities
            ? `<li>
          ${convertValueToLocalString(country.facilities_value)} facilities
        </li>`
            : ""
        }
        <li>
          Direct jobs: ${convertValueToLocalString(country.direct_jobs_value)}
        </li>
        <li>
          Indirect jobs: ${convertValueToLocalString(
            country.indirect_jobs_value
          )}
        </li>
        <li>
          ${country.gdp_contribution_value} of GDP
        </li>
      </ul>
    </div>
  `;
}
